import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import injectSaga from 'utils/injectSaga';
import { createStructuredSelector } from 'reselect';
import { pages } from 'containers/Landing/constants';
import withContentful from 'containers/Landing/withContenfull';
import {
  loadMerchandizedProducts,
  addToOrder,
} from 'containers/PrimoProducts/actions';
import { selectProductsAreFetching } from 'containers/PrimoProducts/selectors';
import { PRODUCTS_KEY } from 'containers/PrimoProducts/constants';
import primoProductsSaga from 'containers/PrimoProducts/saga';
import { selectSsrReqRoute } from 'containers/Landing/selectors';
import PrimoProductPage from './ProductPage';

const mapStateToProps = () =>
  createStructuredSelector({
    productIsFetching: selectProductsAreFetching(),
    ssrReqRoute: selectSsrReqRoute(),
  });

const mapDispatchToProps = {
  loadMerchandizedProducts,
  addToOrder,
};

const withSaga = injectSaga({
  key: PRODUCTS_KEY,
  saga: primoProductsSaga,
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const ProductPageBase = compose(
  withSaga,
  withConnect,
  withRouter,
)(PrimoProductPage);

export const ProductPageLoggedOut = withContentful(pages.productPageLoggedOut)(
  ProductPageBase,
);
